/**
 * Ask the browser to keep this site's storage for good.
 *
 * Without it, IndexedDB is "best effort": under storage pressure the browser
 * may clear it without asking — the offline database with its unsynced edits,
 * and the photo cache, whose every original then comes down from the server
 * again (megabytes each, over a field connection). Chrome grants it silently to
 * an installed or often-used app; Firefox asks the user once.
 *
 * Fire and forget: a refusal changes nothing that worked before.
 */
export async function requestPersistentStorage(): Promise<void> {
    const storage = typeof navigator === 'undefined' ? null : navigator.storage;
    if (!storage?.persist || !storage.persisted) {
        return;
    }
    try {
        if (await storage.persisted()) {
            return;
        }
        await storage.persist();
    } catch {
        // Not allowed here (an insecure origin, a private window): nothing to do.
    }
}
